module.exports = __webpack_public_path__ + "img/tips-food.2b434bfd.svg";